<template>
    <div :class="{ 'card' : !isOnlyContent }">
        <div
            class="card-header"
            :class="{ 'd-none' : isOnlyContent }">
            チャット
        </div>
        <div :class="{ 'card-body' : !isOnlyContent }">
            <div class="chat-room">
                <div class="chat-message">
                    <div
                        v-if="isWaitingScroll"
                        class="d-flex align-items-center justify-content-center p-5">
                        <b-spinner variant="yokumiru-user"></b-spinner>
                    </div>
                    <div v-else>
                        <chat
                            :consultation="consultation"
                            :messages="messages"
                            :participants="participants"
                            :images="images"
                            :timezone="timezone"
                            user-type="doctor"
                            is-admin>
                        </chat>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'

    export default {
        props: {
            consultation: {
                type: Object,
                required: true,
            },
            timezone: {
                type: String,
                required: true,
            },
            isOnlyContent: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                isWaitingScroll: false,
                message: "",
                userName: "",
                chatId: "",
                messages: [],
                participants: [],
                images: [],
            }
        },

        created: function () {
            this.getMessages()
            bus.$on('chat-scroll', this.scrollToLatestMessage)
        },

        beforeDestroy: function () {
            bus.$off('chat-scroll')
        },

        mounted: function () {
            window.Echo.private(`consultation.${this.consultation.id}`)
                .listen('MessageSent', () => {
                    this.getMessages()
                })
                .listen('ConsultationMessageImageDeleted', () => {
                    this.getMessages()
                })
        },

        methods: {
            /**
             * 最新メッセージまでスクロールする（チャットタブ表示時に呼ばれる）
             * v-chat-scroll は messages の変更を検知してスクロールするため、擬似的に messages の状態を変える
             */
            scrollToLatestMessage: function () {
                if (this.isWaitingScroll) return
                this.isWaitingScroll = true

                const messages = this.messages
                this.messages = []

                setTimeout(() => {
                    this.messages = messages
                    this.isWaitingScroll = false
                }, 100)
            },

            /**
             * チャットメッセージ取得
             */
            getMessages: function () {
                const endpoint = `${constants.admin.consultations.endpoint.base}/${this.consultation.id}/messages`

                axios.get(endpoint)
                    .then(({data}) => {
                        this.messages = data.data.messages
                        this.participants = data.data.participants
                        this.images = data.data.images

                        const exists = (this.messages && this.messages.length > 0) || (this.images && this.images.length > 0)
                        bus.$emit('update-tab-css', 'chat', exists)
                    })
            },
        },
    }
</script>

<style lang="scss">
    .is-invalid {
        .custom-file-label {
            border: 1px solid #dc3545;
        }
    }
</style>
